/* istanbul ignore file: Directive */
'use strict';

/**
 * Highlight required fields on the form when the element is clicked
 */
customerZone.directive('highlightRequired', ['utils', function(utils) {
    return {
        restrict: 'A',
        scope: {'onEnter': '&'},
        require: '^form',
        link: function(scope, element, attrs, formCtrl) {
            var errorMessage;
            element.on('click', function(ev) {
                utils.hideError(errorMessage);
                var $parentForm = element.closest('form');
                if ($parentForm.is('.ng-invalid-required')){
                    $parentForm.addClass('highlight-required');
                    errorMessage = utils.showError('please_fill_required_fields');
                }
                else {
                    $parentForm.removeClass('highlight-required');
                }
            });
        }
    };
}]);
